import { omit as _omit } from 'lodash';

import { ExpandedEventInUrl } from '@app/enums';

export {
    redirectWithoutBackOption,
    redirectWithBackOption,
    enterMaintenance,
} from './redirect';

export function removeEventQueryParams(query: Record<string, string>): Record<string, string> {
    return _omit(
        query,
        [
            ExpandedEventInUrl.event,
            ExpandedEventInUrl.type,
            ExpandedEventInUrl.odd,
            ExpandedEventInUrl.sbValue,
            ExpandedEventInUrl.marketGroup,
        ],
    );
}
